import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import {
  DateSelectionContainer,
  DatePicker,
  ControlsSeparator,
  ClearButton,
  SearchButton,
} from './styles';
import { ControlLabel } from '../styles';
import { IAppState } from '../../../../state/reducers';
import { IProps, IStateProps, IDispatchProps } from './interfaces';
import {
  DateSelectionType,
  changeDateSelectionType,
  changeDateFrom,
  changeDateTo,
  clearDateSelection,
} from '../../../../state/exchange/searchParams';
import { queryGames } from '../../../../state/exchange/searchResults';

class ExchangeDateSelection extends React.Component<IProps> {
  handleDateSelectionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { onDateSelectionTypeChange } = this.props;
    onDateSelectionTypeChange(e.target.value as DateSelectionType);
  };

  render() {
    const {
      dateFrom,
      dateTo,
      teamsLoaded,
      onDateFromChange,
      onDateToChange,
      onClearDateSelection,
      onSearch,
    } = this.props;

    const dateFromProps: any = {};
    if (dateTo !== null) {
      dateFromProps.maxDate = dateTo;
    }

    return (
      <>
        <DateSelectionContainer>
          <ControlLabel>
            Date(s):
          </ControlLabel>
          <DatePicker
            variant="inline"
            format="MM-dd-yyyy"
            value={dateFrom}
            disableFuture
            disableToolbar
            onChange={onDateFromChange}
            {...dateFromProps}
            data-auto="DateFromInput"
            slotProps={{
              actionBar: {
                actions: ['clear', 'today'],
              },
            }}
          />
          <ControlsSeparator>
            to
          </ControlsSeparator>
          <DatePicker
            format="MM-dd-yyyy"
            value={dateTo}
            disableFuture
            onChange={(value, context) => onDateToChange(value as Date)}
            data-auto="DateToInput"
            slotProps={{
              actionBar: {
                actions: ['clear', 'today'],
              },
            }}
          />
          <ClearButton
            variant="plainOnPaper"
            onClick={onClearDateSelection}
            data-auto="ClearDateBtn"
          >
            Clear Date(s)
          </ClearButton>
        </DateSelectionContainer>
        <SearchButton
          variant="primaryOnWhite"
          onClick={onSearch}
          data-loaded={teamsLoaded}
          disabled={!teamsLoaded}
          data-auto="SearchBtn"
        >
          Search
        </SearchButton>
      </>
    );
  }
}

const mapStateToProps = (state: IAppState): IStateProps => ({
  dateFrom: state.exchange?.searchParams?.dateRange?.from ?? null,
  dateTo: state.exchange?.searchParams?.dateRange?.to ?? null,
  teamsLoaded: state.exchange?.searchParams?.isLoaded ?? false,
});

const mapDispatchToProps: IDispatchProps = {
  onDateSelectionTypeChange: changeDateSelectionType,
  onDateFromChange: changeDateFrom,
  onDateToChange: changeDateTo,
  onClearDateSelection: clearDateSelection,
  onSearch: queryGames,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExchangeDateSelection);
